import React, { useState, useEffect, Fragment, useRef } from "react";
import NavBarStrainHome from '../NavBarStrainHome'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import CountUp from 'react-countup';
import SidebarStrain from './SidebarStrain';
import {
    Avatar, Box, Button, Grid, Paper, Table, TableCell, TableContainer, TableBody, TableHead,
    TableRow, TextField, Typography, Card, CardContent, CardHeader, Tooltip, Modal, Divider, Backdrop, CircularProgress
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import config from '../../../config.json'
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';

import IconButton from '@mui/material/IconButton';

import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';


import LinearProgress from '@mui/material/LinearProgress';


import GeoDistStates from "./GeoDistStates";

import hospitalnew from '../../../assets/hospital_new.svg'
import marketnew from '../../../assets/market_new.svg'
import foodnew from '../../../assets/food_new.svg'
import hosnew from '../../../assets/hos_new.svg'
import ssfnew from '../../../assets/ssfnew.svg'
import paw from '../../../assets/paw.svg'
import Footer from "../../Footer";
import {jwtDecode} from "jwt-decode";
import {useNavigate} from "react-router-dom";



const useStyle = makeStyles({
    root: {
        "& .MuiDataGrid-columnHeaderTitle": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiDataGrid-cellContent": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiTypography-string": {
            textOverflow: "ellipsis",
            whiteSpace: "break-spaces",
            lineHeight: 2,
            textAlign: "center",
            fontWeight: "bold",

        },
        boxShadow: 2,
        "& .MuiTablePagination-selectLabel": {
            marginTop: "auto",
        },
        "& .MuiTablePagination-displayedRows": {
            marginTop: "auto",
        },
    },
});

const BASE_URL = config.SERVER_URL;

export default function StrainDashboard() {

    const drawerWidth = 260;

    const navigate = useNavigate();



    const [totalstrain, settotalstrain] = useState(0)
    const [totalniced, settotalniced] = useState(0)
    const [totalrmrc, settotalrmrc] = useState(0)
    const [totalmarket, settotalmarket] = useState(0)
    const [totalhospital, settotalhospital] = useState(0)
    const [totalssf, settotalssf] = useState(0)
    const [totalanimal, settotalanimal] = useState(0)

    const [marketniced, setmarketniced] = useState(0)
    const [hospitalniced, sethospitalniced] = useState(0)
    const [ssfniced, setssfniced] = useState(0)
    const [animalniced, setanimalniced] = useState(0)

    const [marketrmrc, setmarketrmrc] = useState(0)
    const [hospitalrmrc, sethospitalrmrc] = useState(0)
    const [ssfrmrc, setssfrmrc] = useState(0)
    const [animalrmrc, setsanimalrmrc] = useState(0)



    const [nicedStrainwise, setnicedStrainwise] = useState([])
    const [rmrcStrainwise, setrmrcStrainwise] = useState([])
    const [statewiseStrains, setstatewiseStrains] = useState()
    const [statewisestrainsgeo, setstatewisestrainsgeo] = useState()

    const [marketstrains, setmarketstrains] = useState([])
    const [marketstrainsuncooked, setmarketstrainsuncooked] = useState([])
    const [hospitalstrains, sethospitalstrains] = useState([])
    const [ssfstrains, setssfstrains] = useState([])
    const [animalstrains, setanimalstrains] = useState([])
    const [states, setstates] = useState([])


    const [backdropopen, setbackdropopen] = useState(true)

    const [minLabel, setminLabel] = useState(98)

    const [cookedmarketpie, setcookedmarketpie] = useState('block')
    const [uncookedmarketpie, setuncookedmarketpie] = useState('block')
    const [hospitalpie, sethospitalpie] = useState('block')
    const [ssfpie, setssfpie] = useState('block')
    const [animalpie, setanimalpie] = useState('block')


    const t1 = sessionStorage.getItem("sessionid")

    var decodet1 = ""

    try {
        decodet1 = jwtDecode(t1)
    } catch (error) {

    }




    //////console.log("token from redux at enter strain page", t1)






    useEffect(() => {

        if (decodet1 === "") {
            navigate("/")
        }

        const getStrains = axios.post(BASE_URL+"/strain/viewStrainNiced",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getCardStats = axios.post(BASE_URL+"/straindashboard/getCardStats",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getStrainWiseStats = axios.post(BASE_URL+"/straindashboard/getStrainWiseCount",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getSourceWiseStats = axios.post(BASE_URL+"/straindashboard/getSourceWiseStrains",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getStateWiseStats = axios.post(BASE_URL+"/straindashboard/getStateWiseStrains",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getStates = axios.post(BASE_URL+"/master/getStates",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        const getStateWiseStatsGeo = axios.post(BASE_URL+"/straindashboard/getStateWiseStrainsGeo",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        Promise.all([getStrains, getCardStats, getStrainWiseStats, getSourceWiseStats, getStateWiseStats, getStates, getStateWiseStatsGeo])
            .then(function (responses) {

                settotalstrain(responses[1].data.Total)
                settotalniced(responses[1].data.TotNiced)
                settotalrmrc(responses[1].data.TotRmrc)
                settotalmarket(responses[1].data.MarketTot)
                settotalhospital(responses[1].data.HospitalTot)
                settotalssf(responses[1].data.SsfTot)
                settotalanimal(responses[1].data.AnimalTot)

                setmarketniced(responses[1].data.MarketNiced)
                sethospitalniced(responses[1].data.HospitalNiced)
                setssfniced(responses[1].data.SsfNiced)
                setanimalniced(responses[1].data.AnimalNiced)

                setmarketrmrc(responses[1].data.MarketRmrc)
                sethospitalrmrc(responses[1].data.HospitalRmrc)
                setssfrmrc(responses[1].data.SsfRmrc)
                setsanimalrmrc(responses[1].data.AnimalRmrc)


                setnicedStrainwise(responses[2].data.Niced)
                setrmrcStrainwise(responses[2].data.Rmrc)

                ////console.log("sourcewise",responses[3].data )


                setmarketstrains(responses[3].data.MarketCooked)
                if (responses[3].data.MarketCooked.length == 0) {
                    setcookedmarketpie('none')
                }
                setmarketstrainsuncooked(responses[3].data.MarketUncooked)
                if (responses[3].data.MarketUncooked.length == 0) {
                    setuncookedmarketpie('none')
                }
                sethospitalstrains(responses[3].data.Hospital)
                if (responses[3].data.Hospital.length == 0) {
                    sethospitalpie('none')
                }
                setssfstrains(responses[3].data.Ssf)
                if (responses[3].data.Ssf.length == 0) {
                    setssfpie('none')
                }
                setanimalstrains(responses[3].data.Animal)
                if (responses[3].data.Animal.length == 0) {
                    setanimalpie('none')
                }


                setstatewiseStrains(responses[4].data)
                setstates(responses[5].data.States)
                setstatewisestrainsgeo(responses[6].data)

                setbackdropopen(false)

                ////console.log("state: ", statewisestrainsgeo)


            })
            .catch(function (errors) {

                //////console.log("strain errors", errors[0]);
            });

    }, []);



    function getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function handleResize() {
        const newWidth = getScreenWidth();


        if (newWidth <= 1920 && newWidth > 1600) {
            setminLabel(99)
        } else if (newWidth <= 1600 && newWidth > 1200) {
            setminLabel(79)
        } else if (newWidth <= 1200 && newWidth > 1000) {
            setminLabel(59)
        } else if (newWidth <= 1000 && newWidth > 800) {
            setminLabel(39)
        } else if (newWidth <= 800 && newWidth > 600) {
            setminLabel(10)
        } else if (newWidth <= 600 && newWidth > 500) {
            setminLabel(19)
        } else if (newWidth <= 500 && newWidth > 400) {
            setminLabel(2)
        }

        // Your other actions on resize, e.g., update layout
    }

    window.addEventListener('resize', handleResize);

    // Call the function initially to get the initial screen width
    const initialWidth = getScreenWidth();

    useEffect(() => {
        if (initialWidth <= 1920 && initialWidth > 1600) {
            setminLabel(99)
        } else if (initialWidth <= 1600 && initialWidth > 1200) {
            setminLabel(79)
        } else if (initialWidth <= 1200 && initialWidth > 1000) {
            setminLabel(59)
        } else if (initialWidth <= 1000 && initialWidth > 800) {
            setminLabel(39)
        } else if (initialWidth <= 800 && initialWidth > 600) {
            setminLabel(10)
        } else if (initialWidth <= 600 && initialWidth > 500) {
            setminLabel(19)
        } else if (initialWidth <= 500 && initialWidth > 400) {
            setminLabel(2)
        }
    }, [])





    //////////////////////// strainwise niced rmrc////////////////////////////////

    let strainarr = nicedStrainwise.map(item => item.subcategoryName);

    let nicedval = nicedStrainwise.map(item => item.count);

    let rmrcval = rmrcStrainwise.map(item => item.count);

    // Filter out zero values and get the corresponding labels
    function filterDataAndLabels(nicedval, strainarr) {
        let filteredData1 = [];
        let filteredLabels = [];

        for (let i = 0; i < nicedval.length; i++) {
            if (nicedval[i] !== 0 ) {
                filteredData1.push(nicedval[i]);
                filteredLabels.push(strainarr[i]);
            }
        }

        return { filteredData1,filteredLabels };
    }

    const { filteredData1, filteredLabels } = filterDataAndLabels(nicedval, strainarr);


    const baroption1 = {
        title: {
            text: 'Strains by Center',
            show: false
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">Pathogens</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {
            show: false
        },
        grid: {
            left: '0.5%',
            right: '0%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            },

        },
        xAxis: {
            type: 'category',
            data: filteredLabels,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 500,
                color: 'black',
                interval: 0,// Adjust font size
                padding: [5, 0, 0, 0],
                formatter: function (value, index) {

                    return value.split(' ').join('\n'); // Split labels by space into multiple lines



                },
                ellipsis: true,
                rotate: 0,
                margin: 25,
                fontStyle: 'italic'
                // formatter: function (value) {
                //     return value.length > 10 ? value.slice(0, 10) + '...' : value;
                //   }


            }
        },
        series: [
            {
                name: 'NICED',
                type: 'bar',
                barWidth: '20%',
                data: filteredData1,
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 15,
                    fontWeight: 600,
                },
                emphasis: {
                    focus: 'series'
                }
            },
            // {
            //     name: 'RMRC-NE',
            //     type: 'bar',
            //     barWidth: '20%',
            //     data: filteredData2,
            //     label: {
            //         show: true,
            //         position: 'top',
            //         fontSize: 15,
            //         fontWeight: 600
            //     },
            //     emphasis: {
            //         focus: 'series'
            //     }
            // }
        ],
        height: 280,
        dataZoom: [{
            type: 'slider',
            show: true,
            start: 2,
            end: minLabel,
            handleSize: '550%',
            height: 1,
            backgroundColor: '#0715ad', // Background color of the slider
            dataBackgroundColor: '#0715ad', // Background color of the data area
            fillerColor: '#0715ad', // Color of the selected area (filler)
            handleColor: '#0715ad', // Color of the handles
            borderColor: '#0715ad',
            labelFormatter: () => '',

        }],

    };



    //////////////////////////////////// state wise pathogens /////////////////////////////////////

    const stateNames = states.map(item => item.stateName);
    const dataArray = [];

    for (const pathogen in statewiseStrains) {
        const pathogenData = [];
        for (const state of statewiseStrains[pathogen]) {
            pathogenData.push(state.count);
        }

        dataArray.push({
            name: pathogen,
            type: 'bar',
            data: pathogenData.map((value, i) => ({
                value: value,
                itemStyle: value === 0 ? { opacity: 0 } : {},
            })),

            label: {
                show: true,
                position: 'top',
                fontSize: 12,
                fontWeight: 600,
                color: '#000000'
            },
            emphasis: {
                focus: 'series'
            }

        });
    }

    //////console.log("State Names:", stateNames);
    //console.log("Data Array:", dataArray);

    const baroption2 = {
        title: {
            text: 'Strains by States',
            show: false
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                // dataView: {
                //     title: 'Table View',
                //     readOnly: false,
                //     lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                //     optionToContent: function (opt) {
                //         var axisData = opt.xAxis[0].data;
                //         var series = opt.series;
                //         var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                //             + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">States</th>'
                //             + series.map(function (item) {
                //                 return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                //             }).join('')
                //             + '</tr></thead><tbody>';
                //
                //         for (var i = 0, l = axisData.length; i < l; i++) {
                //             var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                //             table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                //                 + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                //                 + series.map(function (item) {
                //                     return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                //                 }).join('')
                //                 + '</tr>';
                //         }
                //
                //         table += '</tbody></table></center>';
                //         return table;
                //     }
                // },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '1%',
            right: '1%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            }
        },
        xAxis: {
            type: 'category',
            data: stateNames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 500,
                color: 'black',
                interval: 0,
                formatter: function (value, index) {
                    return dataArray[index] === 0 ? '' : value; // Return empty string for zero values
                }

            },
        },
        series: dataArray,
        height: 280,
        dataZoom: [{
            type: 'slider',
            show: true,
            start: 2,
            end: minLabel,
            handleSize: '550%',
            height: 1,
            backgroundColor: '#0715ad', // Background color of the slider
            dataBackgroundColor: '#0715ad', // Background color of the data area
            fillerColor: '#0715ad', // Color of the selected area (filler)
            handleColor: '#0715ad', // Color of the handles
            borderColor: '#0715ad',
            labelFormatter: () => '',

        }],
    };


    ////////////////////////////////////// food pie chart options//////////////////////////

    const chartdatapie = []

    for (const item of marketstrains) {
        chartdatapie.push({
            value: item.sum,
            name: item.sampleCategoryName
        })
    }

    ////console.log("chartdatapie: ", chartdatapie)

    const pieoption1 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal',
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                top: '10%',
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie
            }
        ]
    };

    ////////////////////////////////////// uncooked food pie chart options//////////////////////////

    const chartdatapieuncooked = []

    for (const item of marketstrainsuncooked) {
        chartdatapieuncooked.push({
            value: item.sum,
            name: item.sampleCategoryName
        })
    }

    ////console.log("chartdatapienew: ", chartdatapieuncooked)

    const pieoption3 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal',
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                top: '10%',
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapieuncooked
            }
        ]
    };

    ///////////////////////////////////////// hospitalpie chart options ////////////////////////////////////

    const chartdatapie2 = []

    for (const item of hospitalstrains) {
        chartdatapie2.push({
            value: item.sum,
            name: item.sampleSubcategoryName
        })
    }

    //////console.log("chartdatapie: ", chartdatapie2)

    const pieoption2 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal'
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                top: '10%',
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie2
            }
        ]
    };

    ////////////////////////// ssf pie chart ////////////////////////////////

    const chartdatapie3 = []

    if (ssfstrains.length > 0) {
        for (const item of ssfstrains) {
            chartdatapie3.push({
                value: item.sum,
                name: item.sampleCategoryName
            })
        }
    }

    //////console.log("chartdatapie: ", chartdatapie2)

    const pieoptionssf = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal'
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                top: '10%',
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie3
            }
        ]
    };


    ///////////////////////////////// animal pie chart /////////////////////////////////////////

    const chartdatapie4 = []

    for (const item of animalstrains) {
        chartdatapie4.push({
            value: item.sum,
            name: item.sampleCategoryName
        })
    }

    //////console.log("chartdatapie: ", chartdatapie2)

    const pieoptionanimal = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal'
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                top: '10%',
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie4
            }
        ]
    };



    /////////////////////////////////////////////////// echarts geomap configs ////////////////////////////////////////

    const pathDatageo = []

    for (const pathogen in statewisestrainsgeo) {

        const seriesData = [];
        for (const state of statewisestrainsgeo[pathogen]) {
            seriesData.push({
                name: state.stateName,
                value: state.count
            })
        }

        pathDatageo.push({
            pathname: pathogen,
            series: seriesData
        })

    }



    //console.log("series", pathDatageo)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    return (
        <>
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` }
                }}>
                <SidebarStrain />

                <div style={{ marginTop: '70px' }}>
                    <div className="body flex-grow-1" style={{ backgroundColor: '#f3f4f7', }}>

                        <div className="row p-4">

                            <div className="row">


                                <Grid container spacing={3} sx={{ marginTop: '10px', alignItems: 'center', justifyContent: 'center' }} >


                                    {/* <Grid item xs={12} sm={12} md={12} lg={4} >
                                        <div style={{
                                            backgroundColor: '#6761d9', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%'
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={totalstrain} /></h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Total Strains</h5>



                                        </div>
                                    </Grid> */}

                                    <Grid item xs={12} sm={12} md={12} lg={6} >
                                        <div style={{
                                            backgroundColor: '#2c88da', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', flex: 1
                                        }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={totalniced} /></h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Strains At ICMR-NIRBI</h5>

                                            {/* <ReactECharts option={option2} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>

                                    {/*<Grid item xs={12} sm={12} md={12} lg={6} >*/}
                                    {/*    <div style={{*/}
                                    {/*        backgroundColor: '#dd3f3f', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', flex: 1*/}
                                    {/*    }}>*/}
                                    {/*        <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'white' }}><CountUp end={totalrmrc} /></h3>*/}
                                    {/*        <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'white' }}>Strains At RMRC-NE</h5>*/}

                                    {/*        /!* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> *!/*/}

                                    {/*    </div>*/}
                                    {/*</Grid>*/}

                                </Grid>


                                <Grid container spacing={3} sx={{ marginTop: '10px' }} >


                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={3} marginTop={5} >
                                        <div style={{
                                            backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',
                                            marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',
                                            position: 'relative', justifyContent: 'center', flexDirection: 'column',
                                            border: '2px solid'
                                        }}>
                                            <Avatar
                                                alt="market"
                                                src={marketnew}
                                                sx={{
                                                    width: 100, height: 100, bgcolor: "#d7e8fc", padding: '15px',
                                                    position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-35px',
                                                }}
                                            />
                                            <div style={{ marginTop: '50px' }}>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Enteric Pathogenic Strains</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Market Surveillance</h5>
                                                {/* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={totalmarket} /></h3> */}

                                            </div>
                                            <div className="row" style={{ width: '100%' }}>
                                                <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>
                                            </div>

                                            <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                                                <div className="row">
                                                    {/*<h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>NIRBI</h5>*/}
                                                    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{marketniced}</h4>

                                                </div>
                                                {/*<div>*/}
                                                {/*    <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>RMRC-NE</h5>*/}
                                                {/*    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{marketrmrc}</h4>*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={3} marginTop={5} >
                                        <div style={{
                                            backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',
                                            marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',
                                            position: 'relative', justifyContent: 'center', flexDirection: 'column', border: '2px solid'
                                        }}>
                                            <Avatar
                                                alt="hos"
                                                src={hosnew}
                                                sx={{
                                                    width: 100, height: 100, bgcolor: "#d0fff1", padding: '15px',
                                                    position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-35px',
                                                }}
                                            />
                                            <div style={{ marginTop: '50px' }}>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Enteric Pathogenic Strains</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Hospital Surveillance</h5>
                                                {/* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={totalhospital} /></h3> */}

                                            </div>
                                            <div className="row" style={{ width: '100%' }}>
                                                <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>
                                            </div>
                                            <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                                                <div className="row">
                                                    {/*<h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>NIRBI</h5>*/}
                                                    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{hospitalniced}</h4>

                                                </div>
                                                {/*<div>*/}
                                                {/*    <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>RMRC-NE</h5>*/}
                                                {/*    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{hospitalrmrc}</h4>*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={3} marginTop={5} >
                                        <div style={{
                                            backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',
                                            marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',
                                            position: 'relative', justifyContent: 'center', flexDirection: 'column', border: '2px solid'
                                        }}>
                                            <Avatar
                                                alt="ssf"
                                                src={ssfnew}
                                                sx={{
                                                    width: 100, height: 100, bgcolor: "#ffebce", padding: '10px',
                                                    position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-35px',
                                                }}
                                            />
                                            <div style={{ marginTop: '50px' }}>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Enteric Pathogenic Strains</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>State Specific Food Surveillance</h5>
                                                {/* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={totalssf} /></h3> */}

                                            </div>
                                            <div className="row" style={{ width: '100%' }}>
                                                <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>
                                            </div>
                                            <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                                                <div className="row">
                                                    {/*<h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>NICED</h5>*/}
                                                    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{ssfniced}</h4>

                                                </div>
                                                {/*<div>*/}
                                                {/*    <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>RMRC-NE</h5>*/}
                                                {/*    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{ssfrmrc}</h4>*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={3} marginTop={5} >
                                        <div style={{
                                            backgroundColor: '#ffffff', borderRadius: '5px', padding: '20px',
                                            marginLeft: '10px', width: '100%', alignItems: 'center', display: 'flex',
                                            position: 'relative', justifyContent: 'center', flexDirection: 'column', border: '2px solid'
                                        }}>
                                            <Avatar
                                                alt="ssf"
                                                src={paw}
                                                sx={{
                                                    width: 100, height: 100, bgcolor: "#89faa4", padding: '10px',
                                                    position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', top: '-35px',
                                                }}
                                            />
                                            <div style={{ marginTop: '50px' }}>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Enteric Pathogenic Strains</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>from</h5>
                                                <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Animal Surveillance</h5>
                                                {/* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center', marginTop: '15px' }}><CountUp end={totalssf} /></h3> */}

                                            </div>
                                            <div className="row" style={{ width: '100%' }}>
                                                <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 1 }}></Divider>
                                            </div>
                                            <div className="container" style={{ width: '100%', alignItems: 'center', justifyContent: 'space-around', display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                                                <div className="row">
                                                    {/*<h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>NICED</h5>*/}
                                                    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{animalniced}</h4>

                                                </div>
                                                {/*<div>*/}
                                                {/*    <h5 style={{ textAlign: 'center', fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>RMRC-NE</h5>*/}
                                                {/*    <h4 style={{ textAlign: 'center', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>{animalrmrc}</h4>*/}
                                                {/*</div>*/}
                                            </div>
                                            {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                        </div>
                                    </Grid>

                                </Grid>

                            </div>


                            <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains identified by ICMR NIRBI</h3>
                                {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Strains Uploaded by Respective Centers</h5> */}
                                <ReactECharts option={baroption1} style={{ height: '400px', width: '100%' }} />



                            </div>

                            <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >

                                <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Identified Strains Accross States</h3>
                                {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>State Wise Count</h5> */}
                                <ReactECharts option={baroption2} style={{ height: '400px', width: '100%' }} />

                            </div>

                            <div className="row mb-5">


                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                    <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: cookedmarketpie }}>
                                        <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px', }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Market Surveillance</h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Cooked Food</h5>
                                            <ReactECharts option={pieoption1} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: uncookedmarketpie }}>
                                        <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px', }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Market Surveillance</h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Uncooked Food</h5>
                                            <ReactECharts option={pieoption3} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: hospitalpie }}>
                                        <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Hospital Surveillance</h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Clinical Sample Strains</h5>
                                            <ReactECharts option={pieoption2} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: ssfpie }}>
                                        <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>State Specific Food Surveillance</h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Ethnic Food Samples </h5>
                                            <ReactECharts option={pieoptionssf} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: animalpie }}>
                                        <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }}>
                                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Animal Surveillance</h3>
                                            <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Animal and Animal Handler Samples</h5>
                                            <ReactECharts option={pieoptionanimal} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                        </div>
                                    </Grid>
                                </Grid>

                                <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginTop: '50px' }}>Geo Distribution Accross States</h3>
                                <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'center' }} >
                                    {
                                        pathDatageo.map((item) => (
                                            <>

                                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                                    <div className="geochartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '25px', }}>
                                                        {/* <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Market Surveillance</h3> */}
                                                        {/* <ReactECharts option={pieoption1} style={{ width: '100%', marginTop: '30px' }} /> */}
                                                        <GeoDistStates text={item.pathname} dataechart={item.series} />
                                                    </div>
                                                </Grid>

                                            </>
                                        ))
                                    }
                                </Grid>



                            </div>





                        </div>



                    </div>
                </div>

                <Footer />
            </Box >
            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>



        </>
    )
}
